module.exports = __webpack_public_path__ + "ne.svg?3d8e6ffb75a0b570cb07c135dfb9cb27";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ne.svg
// module id = 1337
// module chunks = 27